import React from "react";
import {
  Typography,
  IconButton,
  TextField,
  TableRow,
  TableCell,
} from "@mui/material";
import { Edit, Delete, Done } from "@mui/icons-material";

const MiscellaneousListing = ({
  isEditingItem,
  editedItem,
  englishName,
  hindiName,
  itemCode,
  inputChange,
  editClick,
  saveClick,
  deleteClick,
  disableDone = null,
}) => {
  return (
    <TableRow>
      <TableCell>
        {isEditingItem ? (
          <TextField
            name="en"
            value={editedItem?.name?.en || ""}
            onChange={inputChange}
          />
        ) : (
          <Typography>{englishName}</Typography>
        )}
      </TableCell>

      <TableCell>
        {isEditingItem ? (
          <TextField
            name="hi"
            value={editedItem?.name?.hi || ""}
            onChange={inputChange}
          />
        ) : (
          <Typography>{hindiName}</Typography>
        )}
      </TableCell>

      {itemCode ? (
        <TableCell>
          {isEditingItem ? (
            <TextField
              name="code"
              value={editedItem?.code || ""}
              onChange={inputChange}
            />
          ) : (
            <Typography>{itemCode}</Typography>
          )}
        </TableCell>
      ) : null}

      <TableCell>
        {isEditingItem ? (
          <IconButton
            aria-label="save"
            color="primary"
            onClick={saveClick}
            disabled={disableDone}
          >
            <Done />
          </IconButton>
        ) : (
          <IconButton aria-label="edit" color="primary" onClick={editClick}>
            <Edit />
          </IconButton>
        )}
        <IconButton aria-label="delete" color="error" onClick={deleteClick}>
          <Delete />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default MiscellaneousListing;
